// src/hooks/use-described-by.tsx
var useDescribedBy = (...args) => [...args].filter(Boolean).join(" ");

export {
  useDescribedBy
};
